import React from 'react';
import PillarPageTemplate from '../../components/PillarPageTemplate';
import { codeMotoGratuitData } from '../../data/pillars/codeMotoGratuit';

export default function PillarCodeMotoGratuit() {
  return <PillarPageTemplate data={codeMotoGratuitData} />;
}
